import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const Input = styled.input`
  height: 42px;
  width: 100%;
  border-radius: 10px;
  border: none;
  padding: 0.7rem;
  outline: none;
  border: 1px solid ${({ hasError }) => (hasError ? 'red' : '#afafaf')};
`;
